module.exports = __webpack_public_path__ + "fonts/rubik-medium-webfont.fe079588.fe079588.woff";